import 'eventsource/lib/eventsource-polyfill.js'; // EventSource polyfill (for edge) 

/**
 * Server Sent Event
 * @source https://developer.mozilla.org/en-US/docs/Web/API/Server-sent_events/Using_server-sent_events
 */
export class SSE {
    constructor ({url, withCredentials}) {
        this.eventSource = new EventSource(url, {withCredentials: withCredentials});
    }

    on(event, callback) {
        this.eventSource.addEventListener(event, callback);
    }

    close() {
        this.eventSource.close();
    }
}


// WEBPACK FOOTER //
// ./src/helper/sse.js